"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.NotificationStatus = exports.Status = exports.Priority = exports.Application = exports.AlertAction = void 0;
var AlertAction;
(function (AlertAction) {
    AlertAction["CREATED"] = "CREATED";
    AlertAction["DELETED"] = "DELETED";
    AlertAction["ESCALATED"] = "ESCALATED";
    AlertAction["STATUS_UPDATED"] = "STATUS_UPDATED";
    AlertAction["OWNER_CHANGED"] = "OWNER_CHANGED";
    AlertAction["NOTIFICATION_STATUS_UPDATED"] = "NOTIFICATION_STATUS_UPDATED";
})(AlertAction = exports.AlertAction || (exports.AlertAction = {}));
var Application;
(function (Application) {
    Application["All"] = "all";
    Application["People"] = "people";
    Application["Partner"] = "partner";
    Application["Legalshield"] = "legalshield";
    Application["LegalshieldV2"] = "legalshieldv2";
    Application["Status"] = "status";
    Application["Idshield"] = "idshield";
})(Application = exports.Application || (exports.Application = {}));
var Priority;
(function (Priority) {
    Priority["Low"] = "Low";
    Priority["Medium"] = "Medium";
    Priority["High"] = "High";
    Priority["Critical"] = "Critical";
})(Priority = exports.Priority || (exports.Priority = {}));
var Status;
(function (Status) {
    Status["Unread"] = "Unread";
    Status["Acknowledged"] = "Acknowledged";
    Status["Resolved"] = "Resolved";
    Status["Deleted"] = "Deleted";
    Status["Dismissed"] = "Dismissed";
})(Status = exports.Status || (exports.Status = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["FAILED"] = "FAILED";
    NotificationStatus["SUCCESS"] = "SUCCESS";
    NotificationStatus["MIXED"] = "MIXED";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://alerts.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Alerts API
 * @version v1
 * @baseUrl https://alerts.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsFetchAlertsForApplication
             * @request GET:/v1/alerts
             * @secure
             */
            alertsFetchAlertsForApplication: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsCreateAlertForApplication
             * @request POST:/v1/alerts
             * @secure
             */
            alertsCreateAlertForApplication: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsEscalateAlertPriority
             * @request POST:/v1/alerts/{alertId}/escalate
             * @secure
             */
            alertsEscalateAlertPriority: (alertId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}/escalate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsResolveAlert
             * @request POST:/v1/alerts/{alertId}/resolve
             * @secure
             */
            alertsResolveAlert: (alertId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}/resolve`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsUpdateNotificationStatus
             * @request POST:/v1/alerts/{alertId}/updateNotificationStatus
             * @secure
             */
            alertsUpdateNotificationStatus: (alertId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}/updateNotificationStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsRemoveAlert
             * @request DELETE:/v1/alerts/{alertId}
             * @secure
             */
            alertsRemoveAlert: (alertId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateGetAlertTemplates
             * @request GET:/v1/alerts/templates
             * @secure
             */
            alertTemplateGetAlertTemplates: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateCreateAlertTemplateResource
             * @request POST:/v1/alerts/templates
             * @secure
             */
            alertTemplateCreateAlertTemplateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateUpdateAlertTemplateResource
             * @request PUT:/v1/alerts/templates
             * @secure
             */
            alertTemplateUpdateAlertTemplateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateGetAlertTemplateForKey
             * @request GET:/v1/alerts/templates/{templateKey}
             * @secure
             */
            alertTemplateGetAlertTemplateForKey: (templateKey, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates/${templateKey}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateRemoveAlertTemplateResource
             * @request DELETE:/v1/alerts/templates/{templateKey}
             * @secure
             */
            alertTemplateRemoveAlertTemplateResource: (templateKey, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates/${templateKey}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsFetchAlertsForIdentity
             * @request GET:/v1/identities/{identityId}/alerts
             * @secure
             */
            identityAlertsFetchAlertsForIdentity: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsCreateAlertForIdentity
             * @request POST:/v1/identities/{identityId}/alerts
             * @secure
             */
            identityAlertsCreateAlertForIdentity: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsAcknowledgeAlert
             * @request POST:/v1/identities/{identityId}/alerts/{alertId}/acknowledge
             * @secure
             */
            identityAlertsAcknowledgeAlert: (alertId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts/${alertId}/acknowledge`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsDismissAlert
             * @request POST:/v1/identities/{identityId}/alerts/{alertId}/dismiss
             * @secure
             */
            identityAlertsDismissAlert: (alertId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts/${alertId}/dismiss`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsChangeOwner
             * @request POST:/v1/identities/{identityId}/alerts/{alertId}/changeOwner
             * @secure
             */
            identityAlertsChangeOwner: (identityId, alertId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts/${alertId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags Journal
             * @name AlertsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/alerts/journal
             * @secure
             */
            alertsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Journal
             * @name JournalGetJournalMaxClock
             * @request GET:/v1/alerts/journal/maxClock
             * @secure
             */
            journalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=alerts.js.map